<template>
  <v-dialog max-width="1000"
            scrollable
            v-model="dialog">

    <v-card>
      <v-card-title>
        Modifier les SKUs
        <v-spacer/>
        <v-icon @click="dialog=false">mdi-close</v-icon>
      </v-card-title>
      <v-divider/>

      <v-card-text class="pa-8 dialog-scroll-target">


        <v-card
            outlined
            class="rounded-lg mb-3"
            v-if="investigation.investigation?.use_grading_criteria"
        >

          <v-card-text>

            <v-select :error-messages="errors.skus"
                      :items="investigation.investigation.skus"
                      outlined
                      dense
                      v-model="skus"
                      label="SKUs à vérifier (obligatoires)"
                      item-value="id"
                      item-text="sku"
                      multiple
                      chips
                      class="custom-chip"
                      deletable-chips
                      hint="Sélectionnez les SKUs dont la présence sera vérifiée lors de cette tâche."
                      persistent-hint
            />
          </v-card-text>

          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="success"
                   depressed
                   dark
                   class="rounded-lg"
                   @click="save"
                   :loading="btnLoading">
              <v-icon left>mdi-content-save-outline</v-icon>
              Mettre à jour
            </v-btn>
          </v-card-actions>

        </v-card>


        <v-card outlined class="rounded-lg mb-3" v-for="(response,i) in investigation.responses" :key="i">

          <v-card-text>
            <v-chip text-color="gifty"
                    label
                    class="bg-subtle-gifty"
            >
              Tâche N° : {{ i + 1 }}
            </v-chip>
          </v-card-text>

          <v-divider/>

          <v-card-text class="grey lighten-5">
            <v-row>
              <v-col cols="6" class="d-flex align-center">
                <v-icon class="mr-2">mdi-book-open</v-icon>
                <h4 class="grey--text text--darken-3">Intitulé</h4>
              </v-col>
              <v-col cols="6" class="d-flex align-center">
                <v-icon class="mr-2">mdi-message-reply-text</v-icon>
                <h4 class="grey--text text--darken-3">Réponse</h4>
              </v-col>
            </v-row>
          </v-card-text>


          <v-divider/>

          <v-card-text>
            <v-row>

              <v-col cols="6">
                <p>
                  {{ response.task.question.fr }}
                </p>
                <div v-if="response.task.question_type.key === 'image'">
                  <v-row>
                    <v-col cols="3">
                      <v-img width="100%"
                             height="100%"
                             @click="[lightboxImage = [{src: FILE_URL + response.task.file}],visible = true]"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + response.task.file"></v-img>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="response.task.question_type.key === 'multiple_images'">
                  <v-row>
                    <v-col cols="3" v-for="(image,imgIndex) in response.task.files" :key="imgIndex">
                      <v-img v-if="image"
                             width="100%"
                             height="100%"
                             @click="showLightbox(imgIndex,response.task.files)"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + image"></v-img>
                    </v-col>
                  </v-row>
                </div>

              </v-col>

              <v-col cols="6">

                <v-alert color="info" text :icon="response.task.answer_type.icon" dense>
                  {{ response.task.answer_type.description.fr }}
                </v-alert>

                <div v-if="response.task.answer_type.key === 'multiple_images'">
                  <v-row>
                    <v-col cols="3" v-for="(image,imgIndex) in response.response?.data" :key="imgIndex">
                      <v-img v-if="image"
                             width="100%"
                             height="100%"
                             @click="showLightbox(imgIndex,response.response?.data)"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + image"></v-img>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="response.task.answer_type.key === 'image'">
                  <v-row>
                    <v-col cols="3">
                      <v-img width="100%"
                             height="100%"
                             @click="[lightboxImage = [{src: FILE_URL + response.response?.data}],visible = true]"
                             class="rounded-lg grey lighten-4 cursor-zoom"
                             :src="FILE_URL + response.response?.data"></v-img>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="response.task.answer_type.key === 'short_paragraph'
                 || response.task.answer_type.key === 'paragraph'
                 || response.task.answer_type.key === 'date'
                 || response.task.answer_type.key === 'time'">
                  <template v-if="/^(https?:\/\/|www\.)/i.test(response.response?.data)">
                    <a :href="response.response?.data.startsWith('http')? response.response?.data : 'https://' + response.response?.data"
                       target="_blank"
                       rel="noopener noreferrer"
                       class="text-primary"
                    >
                      {{ response.response?.data }}
                    </a>
                  </template>
                  <template v-else>
                    {{ response.response?.data }}
                  </template>
                </div>


                <div v-if="response.task.answer_type.key === 'file'">
                  <!--TODO-->
                </div>

                <div v-if="response.task.answer_type.key === 'audio'">
                  <!--TODO-->
                </div>

                <div v-if="response.task.answer_type.key === 'video'">
                  <!--TODO-->
                </div>

                <div v-if="response.task.answer_type.key === 'checkbox' || response.task.answer_type.key === 'radio'">


                  <div
                      v-for="(option, optionIndex) in response.task.task_question_options"
                      :key="optionIndex"
                      class="table-border pa-2 mb-1 rounded d-flex align-center justify-space-between"
                      style="cursor: pointer"
                  >
                    {{ option.option?.option?.fr }}


                    <div v-if="response.task.answer_type.key === 'checkbox'">
                      <v-icon color="success" v-if="response.response?.data?.includes(option.id)">
                        mdi-checkbox-marked
                      </v-icon>
                      <v-icon v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </div>


                    <div v-else-if="response.task.answer_type.key === 'radio'">
                      <v-icon color="success" v-if="response.response?.data === option.id">
                        mdi-radiobox-marked
                      </v-icon>
                      <v-icon v-else>
                        mdi-radiobox-blank
                      </v-icon>
                    </div>
                  </div>

                </div>

              </v-col>

            </v-row>
          </v-card-text>

        </v-card>

      </v-card-text>

    </v-card>

    <vue-easy-lightbox
        :visible="visible"
        :imgs="lightboxImage"
        :index="index"
        @hide="visible = false"></vue-easy-lightbox>

  </v-dialog>

</template>

<script>
import {HTTP} from "@/http-common";

export default {
  emits: ["refresh"],
  data() {
    return {
      overlay: false,
      isLoading: false,
      btnLoading: false,
      is_required_skus: true,
      dialog: false,
      remark: null,
      investigation: {},
      errors: {},
      skus: [],

      /**Lightbox**/
      FILE_URL: process.env.VUE_APP_FILE_URL,
      lightboxImage: "",
      visible: false,
      index: 0,
    }
  },
  methods: {
    open(investigation) {

      this.errors = {}
      this.is_required_skus = true
      this.remark = investigation.remark ?? null
      this.investigation = investigation

      this.skus = this.investigation.investigation.skus.filter(
          sku => sku.selected
      )

      const responses = investigation.grading_rule_responses || []

      this.investigation.investigation.grading_rules =
          (investigation.investigation.grading_rules || []).map(rule => {
            const response = responses.find(
                r => r.grading_rule_id === rule.id
            )

            return {
              ...rule,
              status: response ? response.status : 'non_conform'
            }
          })

      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    save() {
      this.btnLoading = true
      HTTP.post('/v1/opus/backoffice/investigations/notation/edit-sku', {
        submission_id: this.investigation.id,
        skus: this.skus,
      }).then(() => {
        this.btnLoading = false
        this.$successMessage = "Opération réussi !"
        this.dialog = false
        this.$emit('refresh')
      }).catch(err => {
        this.btnLoading = false

        if (err.response && err.response.data.errors) {
          this.errors = err.response.data.errors
          this.scrollToTop()
        }

        console.log(err)
      })
    },

    scrollToTop() {
      this.$nextTick(() => {
        const el = document.querySelector('.dialog-scroll-target')
        if (el) el.scrollTo({top: 0, behavior: 'smooth'})
      })
    },
    showLightbox(index, imgs) {
      if (imgs && imgs.length) {
        this.lightboxImage = imgs.map((img) => {
          return {src: this.FILE_URL + img}
        });
        this.index = index;
        this.visible = true;
      }
    }
  },
}
</script>

<style>
.bg-subtle-gifty {
  background-color: rgba(214, 12, 86, 0.15) !important;
}

.custom-chip .v-chip:not(.v-chip--active) {
  background: #d60c56 !important;
  color: white;
}

.custom-chip .v-chip:not(.v-chip--active) .mdi-close-circle {
  color: white;
}

.vel-img {
  max-width: none !important;
  height: auto !important;
}

.vel-modal img {
  max-width: none !important;
}

</style>